const EMPTY_THREADS = [];

const getCanonicalThreads = (pieveState) => {
  if (Array.isArray(pieveState?.threads)) {
    return pieveState.threads;
  }

  const legacyThreadItems = Object.entries(pieveState?.threadMetaById || {})
    .map(([threadId, threadMeta]) => {
      const normalizedThreadId = String(threadMeta?.id || threadMeta?.threadId || threadId || '').trim();

      if (!normalizedThreadId) {
        return null;
      }

      if (threadMeta?.id === normalizedThreadId || threadMeta?.threadId === normalizedThreadId) {
        return threadMeta;
      }

      return {
        ...threadMeta,
        id: normalizedThreadId
      };
    })
    .filter(Boolean);

  return legacyThreadItems.length > 0 ? legacyThreadItems : EMPTY_THREADS;
};

export default getCanonicalThreads;
